module.exports = __webpack_public_path__ + "img/w3_pause_white.9d0f893e.png";